var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderNow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#141f38;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "credit-card-back-outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448,89.6H63.85A64,64,0,0,0,0,153.45V358.55A64,64,0,0,0,63.85,422.4H448.15A64,64,0,0,0,512,358.55v-205A64.19,64.19,0,0,0,448,89.6ZM25.6,153.51A38.31,38.31,0,0,1,63.91,115.2H448a38.44,38.44,0,0,1,38.4,38.4H25.6ZM486.4,179.2v25.6H25.6V179.2Zm0,179.29a38.31,38.31,0,0,1-38.31,38.31H63.91A38.31,38.31,0,0,1,25.6,358.49V230.4H486.4ZM64,294.4a12.8,12.8,0,0,1,12.8-12.8h76.8a12.8,12.8,0,0,1,0,25.6H76.8A12.8,12.8,0,0,1,64,294.4Zm0,51.2a12.8,12.8,0,0,1,12.8-12.8H217.6a12.8,12.8,0,0,1,0,25.6H76.8A12.8,12.8,0,0,1,64,345.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderNow);
export default __webpack_public_path__ + "static/media/order_now.219499a32edf2b1d1c94a188249ca251.svg";
export { ForwardRef as ReactComponent };